/** GST state codes — the first two digits of a GSTIN, and what decides
 * CGST+SGST vs IGST on every invoice we raise. */
export const GST_STATES = {
    '01': 'Jammu and Kashmir',
    '02': 'Himachal Pradesh',
    '03': 'Punjab',
    '04': 'Chandigarh',
    '05': 'Uttarakhand',
    '06': 'Haryana',
    '07': 'Delhi',
    '08': 'Rajasthan',
    '09': 'Uttar Pradesh',
    '10': 'Bihar',
    '11': 'Sikkim',
    '12': 'Arunachal Pradesh',
    '13': 'Nagaland',
    '14': 'Manipur',
    '15': 'Mizoram',
    '16': 'Tripura',
    '17': 'Meghalaya',
    '18': 'Assam',
    '19': 'West Bengal',
    '20': 'Jharkhand',
    '21': 'Odisha',
    '22': 'Chhattisgarh',
    '23': 'Madhya Pradesh',
    '24': 'Gujarat',
    '26': 'Dadra and Nagar Haveli and Daman and Diu',
    '27': 'Maharashtra',
    '29': 'Karnataka',
    '30': 'Goa',
    '31': 'Lakshadweep',
    '32': 'Kerala',
    '33': 'Tamil Nadu',
    '34': 'Puducherry',
    '35': 'Andaman and Nicobar Islands',
    '36': 'Telangana',
    '37': 'Andhra Pradesh',
    '38': 'Ladakh',
    '97': 'Other Territory',
};
export function stateNameForCode(code) {
    return GST_STATES[code];
}
export function stateCodeForName(name) {
    const target = name.trim().toLowerCase();
    return Object.entries(GST_STATES).find(([, n]) => n.toLowerCase() === target)?.[0];
}
const GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
/** Structural check plus the checksum in the 15th character. */
export function isValidGstin(gstin) {
    const value = gstin.trim().toUpperCase();
    if (!GSTIN_RE.test(value))
        return false;
    if (!GST_STATES[value.slice(0, 2)])
        return false;
    const alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let sum = 0;
    for (let i = 0; i < 14; i += 1) {
        const code = alphabet.indexOf(value[i]);
        if (code < 0)
            return false;
        const factor = i % 2 === 0 ? 1 : 2;
        const product = code * factor;
        sum += Math.floor(product / alphabet.length) + (product % alphabet.length);
    }
    const checksum = (alphabet.length - (sum % alphabet.length)) % alphabet.length;
    return alphabet[checksum] === value[14];
}
export function stateCodeFromGstin(gstin) {
    const code = gstin.trim().slice(0, 2);
    return GST_STATES[code] ? code : null;
}
/**
 * GST slabs after the 22 September 2025 reform ("GST 2.0"), which collapsed the
 * old four-slab system: the 12% and 28% slabs were removed, leaving 5% and 18%
 * as the mainstream rates plus a 40% special rate for a few luxury/sin goods.
 * Most printing (services and printed advertising material) sits at 18%; some
 * printed matter (books, certain stationery) is 5% or nil. 0 stays for exempt.
 */
export const GST_RATES = [0, 5, 18, 40];
export function isValidPincode(pincode) {
    return /^[1-9][0-9]{5}$/.test(pincode.trim());
}
//# sourceMappingURL=gst.js.map